import { __DEFAULT__DSP } from "./../../bom-phu-lieu/bom-model/bom.model";
import { TreeBTP, LoopGiaiDoan } from "./../bom-model/bom.model";
import { BOMService } from "../bom-service/bom.service";
import { DungChungService } from "app/views/pages/nfc/dung-chung/__services/dung-chung.service";
import {
	Component,
	OnInit,
	Input,
	ChangeDetectionStrategy,
	HostListener,
	ElementRef,
	ViewChild,
	ChangeDetectorRef,
	ViewRef,
	Output,
	EventEmitter,
} from "@angular/core";
import {
	Observable,
	fromEvent,
	of,
	BehaviorSubject,
	ReplaySubject,
} from "rxjs";
import { distinctUntilChanged, tap, debounceTime } from "rxjs/operators";
import { Moment } from "moment";
import * as moment from "moment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TokenStorage } from "app/core/auth/_services/token-storage.service";
import { LayoutUtilsService } from "app/core/_base/crud/utils/layout-utils.service";
import {
	RdBoM,
	RdBoMBtp,
	RdBoMCt,
} from "../../cong-thuc-dinh-muc/cong-thuc-dinh-muc-model/cong-thuc-dinh-muc.model";
import { FunctionPublic } from "../../../dung-chung/__function/common_function";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonConFig } from "../../../dung-chung/__model/common_config.model";
import { MAT_STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";

@Component({
	selector: "kt-bom-step-two",
	templateUrl: "./bom-step-two.component.html",
	styleUrls: ["../bom.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{
			provide: MAT_STEPPER_GLOBAL_OPTIONS,
			useValue: {
				displayDefaultIndicatorType: false,
			},
		},
	],
})
export class BOMStepTwoComponent implements OnInit {
	CONFIG: CommonConFig;

	@Input() NLChinh: string[] = [];
	@Input() ThanhPham: string = "";
	public TreeStep2 = new BehaviorSubject<any[]>([]);
	@Input() edit: boolean = false;
	@Output() ListBTPSelected = new EventEmitter<any[]>();
	@Output() OuputTreeStep2 = new EventEmitter<any[]>();
	@Output() clear = new EventEmitter<boolean>();
	@Output() IsChanged = new EventEmitter<boolean>(false);
	@Input() set TreeQT(value: any[]) {
		console.log(value);
		this.TreeStep2.next(value);
		this.changeDetect.detectChanges();
	}

	@Input() DSP: number;

	list_BTP: any[] = [];
	BTP_FilterCtrl: string = "";
	filtered_BTP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListGiaiDoan: any[] = [];

	constructor(
		private MainFormFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private DungChungService: DungChungService,
		private el: ElementRef,
		//private bomEdit: BOMEditComponent,
		private service: BOMService
	) {}

	ngOnInit(): void {
		this.CONFIG = new CommonConFig();
		this.GetSoGiaiDoan();
		this.GetListThanhPham();
	}

	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}

	async GetListThanhPham() {
		let res = await this.service.GetListThanhPham().toPromise();
		if (res && res.status === 1) {
			this.list_BTP = res.data.filter((ts) => ts.IdLoaihh == 5);
			this.list_BTP = this.list_BTP.sort((a, b) => {
				return a.Ma < b.Ma ? -1 : a.Ma > b.Ma ? 1 : 0;
			});
			this.filtered_BTP.next(this.list_BTP.slice());
			this.changeDetectView();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}
	}

	filterBTP() {
		if (!this.list_BTP) {
			return;
		}
		let search = this.BTP_FilterCtrl;
		if (!search) {
			this.filtered_BTP.next(this.list_BTP.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filtered_BTP.next(
			this.list_BTP.filter(
				(ts) =>
					(ts.Ma
						? ts.Ma.toLowerCase().indexOf(search) > -1
						: false) ||
					(ts.Ten ? ts.Ten.toLowerCase().indexOf(search) > -1 : false)
			)
		);
		this.changeDetectView();
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}

	changeBTP(item: LoopGiaiDoan) {
		let index1 = this.list_BTP.findIndex((x) => x.Id == item.IdBTP);
		item.MaBTP = this.list_BTP[index1].Ma;
		item.TenBTP = this.list_BTP[index1].Ten;
		//this.IsChanged.emit(true);
		this.onChangesInputParent();
		this.func__clear();
		this.changeDetectView();
	}

	findCodeBTP(id: number) {
		return id > 0 ? this.list_BTP.find((x) => x.Id == id).Ma : "";
	}

	getErrorMessage(n: number) {
		if (!n) return "Hiệu suất là bắt buộc";
		if (n < 0 || n > 100) return "Hiệu suất phải lớn hơn 0 và bé hơn 100";
		return "";
	}

	checkDisabledBTP(IdBTP: number) {
		let flag = false;
		this.TreeStep2.value.forEach((tr) => {
			tr.ListLoopGiaiDoan.forEach((loop) => {
				if (loop.IdBTP && Number(loop.IdBTP) == IdBTP) {
					flag = true;
					return;
				}
			});
		});
		return flag;
	}

	ouputListBTP() {
		var listBTPSelected = [];
		this.TreeStep2.value.forEach((tr) => {
			var indexTree = this.TreeStep2.value.indexOf(tr);
			tr.ListLoopGiaiDoan.forEach((loop) => {
				if (indexTree < this.TreeStep2.value.length - 1)
					if (
						tr.ListLoopGiaiDoan.indexOf(loop) >=
						tr.ListLoopGiaiDoan.length - 1
					)
						return;
				if (indexTree == this.TreeStep2.value.length - 1)
					if (
						tr.ListLoopGiaiDoan.indexOf(loop) >=
						tr.ListLoopGiaiDoan.length
					)
						return;
				var d =
					tr.ListLoopGiaiDoan[tr.ListLoopGiaiDoan.indexOf(loop) + 1];

				if ((d && !Number(d.IdBTP)) || (!d && !tr.IdThanhPham)) return;
				var rObj = {};
				rObj["HieuSuat"] = loop.HieuSuat;
				rObj["IdBTP"] = d ? Number(d.IdBTP) : tr.IdThanhPham;
				rObj["MaBTP"] = d ? d.MaBTP : tr.MaThanhPham;
				rObj["TenBTP"] = d ? d.TenBTP : tr.TenThanhPham;
				rObj["IdGiaiDoan"] = loop.IdGiaiDoan;
				rObj["TenGiaiDoan"] = loop.TenGiaiDoan;
				rObj["IsThanhPham"] =
					tr.ListLoopGiaiDoan.indexOf(loop) + 1 ==
					tr.ListLoopGiaiDoan.length;
				rObj["ThuocBTP"] =
					this.TreeStep2.value.indexOf(tr) <
					this.TreeStep2.value.length - 1
						? tr.ListLoopGiaiDoan[tr.ListLoopGiaiDoan.length - 1]
								.IdBTP
						: tr.IdThanhPham;
				rObj["NSTBCN"] = null;
				rObj["NSTBTB"] = [];
				listBTPSelected.push(rObj);
			});
		});
		return listBTPSelected;
	}

	changeHieuSuat(event: any, item: LoopGiaiDoan) {
		item.HieuSuat = event ? Number(event) : 0;
		this.changeDetectView();
	}

	onChangesInputParent() {
		this.OuputTreeStep2.emit(this.TreeStep2.value);
	}

	doneStep2() {
		var value = this.ouputListBTP();
		var open = true;
		switch (this.DSP) {
			case __DEFAULT__DSP.AD_FD:
			case __DEFAULT__DSP.VIEN: {
				// Logic ở đây được thiếu BTP giai đoạn 1, 2, 3
				this.ListGiaiDoan.forEach((x, index) => {
					if (index != this.ListGiaiDoan.length - 1) return;
					var btp = value.find(
						(z) => z.IdGiaiDoan == x.QtsxGiaidoanId
					);
					if (btp != null) {
						if (!btp.IdBTP) open = false;
					} else {
						open = false;
					}
				});
				break;
			}
			case __DEFAULT__DSP.HON_HOP: {
				// Mở cho giai đoạn 1 được trống
				open =
					value.length > 0 &&
					value.filter((x) => x.HieuSuat > 0).length ==
						value.length &&
					value.filter((x) => x.IdBTP > 0).length == value.length;
				break;
			}
		}
		return value.length > 0 && open && this.DSP;
	}

	keyUpInput(event) {
		FunctionPublic.preventAlphaV2(event);
	}

	func__clear() {
		this.clear.emit(true);
	}

	async GetSoGiaiDoan() {
		let res = await this.service.GetSoGiaiDoan().toPromise();
		if (res && res.status === 1) {
			this.ListGiaiDoan = res.data ? res.data : [];
			this.changeDetectView();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
			this.changeDetectView();
		}
	}
}
